import { useState, useEffect } from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { projectFirestore } from '../firebase/config';
import useSections from '../hooks/useSections';

export default function Cat() {
  const [covers, setCovers] = useState({});
  const { sections } = useSections();
  const displaySections = sections.filter(s => s.enabled !== false && s.key !== 'images');

  useEffect(() => {
    const unsub = projectFirestore.collection('covers')
      .onSnapshot((snap) => {
        const data = {};
        snap.forEach(doc => {
          data[doc.id] = doc.data().url;
        });
        setCovers(data);
      });
    return () => unsub();
  }, []);

  const getCover = (section) => covers[section.key] || section.defaultCover || '';

  return (
    <>
      <Row xs={1} md={3} className="g-4">
        {displaySections.map((section) => {
          const coverImg = getCover(section);
          if (!coverImg) return null;
          return (
            <Col key={section.key}>
              <a href={section.key}>
                <Card className="rounded shadow acd">
                  <Card.Img variant="top" className="rounded shadow" src={coverImg} />
                </Card>
              </a>
            </Col>
          );
        })}
      </Row>
    </>
  );
}